// App imports
import { BaseService } from '@zaoblako/web/core/services/base.service';

// Shared imports
import { NumberPrefixEnum } from '@zaoblako/shared/common/enums/number-prefix.enum';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ReportItemsPageInterface } from '@zaoblako/shared/common/dtos/report/report-items-page.dto';
import type { PassageTaskFindManyQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-task/passage-task-find-many-query.dto';
import type { PassageTaskStatusEnum } from '@zaoblako/shared/modules/pacs/enums/passage-task-status.enum';
import type { PassageTaskFindInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-task/passage-task-find.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';

// External libs imports
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PassageTaskService extends BaseService {
  protected baseUrl = '/pacs/base/passage-task';

  protected numberPrefix = NumberPrefixEnum.PASSAGE_TASK_PREFIX;

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public findRegistryPage(
    query?: PassageTaskFindManyQueryInterface
  ): Observable<ReportItemsPageInterface<PassageTaskFindInterface>> {
    return this.http.get<ReportItemsPageInterface<PassageTaskFindInterface>>(`${this.baseUrl}/items`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }

  public switchStatusById(id: number, status: PassageTaskStatusEnum): Observable<PassageTaskFindInterface> {
    return this.http.post<PassageTaskFindInterface>(`${this.baseUrl}/${id}/switch-status`, { status });
  }

  public switchStatusByNumber(number: number, status: PassageTaskStatusEnum): Observable<PassageTaskFindInterface> {
    return this.http.post<PassageTaskFindInterface>(`${this.baseUrl}/${this.numberPrefix}-${number}/switch-status`, { status });
  }

  public restoreOneById(id: number): Observable<PassageTaskFindInterface> {
    return this.http.post<PassageTaskFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public restoreOneByNumber(number: number): Observable<PassageTaskFindInterface> {
    return this.http.post<PassageTaskFindInterface>(`${this.baseUrl}/${this.numberPrefix}-${number}/restore`, {});
  }

  public getHistoryForOneById(id: number, query?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }

  public getHistoryForOneByNumber(number: number, query?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${this.numberPrefix}-${number}/history`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }
}
